import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { GetMoneyValue, getThousandComma } from "../../Api/ApiCommon";
import { GetServiceSetData } from "../../Api/ServiceDatas";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import Flex from "../../components/DefaultStyles/Flex";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import { PartyInfoFilterContainer } from "../../components/pages/Party/PartyInfo/PartyInfoFilter";
import LineBtn from "../../components/Button/LineBtn";
import ConfirmBtn from "../../components/Button/ConfirmBtn";
import CouponPointRegisterModal from "../../components/pages/Benefit/Coupon/CouponPointRegisterModal";
import { toast } from "react-toastify";
import Loader from "../../components/DefaultStyles/Loader";
import couponPromotionData from "../../datafiles/promotion_set.json";
import { exportJsonToExcel } from "../../AdminApi/commFunc";
import { authType } from "../Login";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { TotalCount } from "../Users/UserInfo";
import FilterIcon from "../../components/DefaultStyles/FilterIcon";

interface ICoupon {
  id: string;
  partyid: string;
  code: string;
  expdate: string;
  promotion: string;
  regdate: string;
  remain: number;
  servsubsid: number;
  uid: string;
  usedate?: string;
  servId: number;
}

export const couponManagePageState = atom<number>({
  key: "couponManagePageState",
  default: 0,
});

export const couponUseDropdownState = atom<OptionType>({
  key: "couponUseDropdownState",
  default: { value: "", label: "사용 여부" },
});

export const couponFilteringValueState = atom<{ isUse: number }>({
  key: "couponFilteringValueState",
  default: { isUse: 100 },
});

export default function CouponManage() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(couponManagePageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [useDropdownValue, setUseDropdownValue] = useRecoilState<OptionType>(couponUseDropdownState);
  const [couponRegisterModal, setCouponRegisterModal] = useState(false);
  const [couponToastModal, setCouponToastModal] = useState(false);
  const [filteringValue, setFilteringValue] = useRecoilState<{ isUse: number }>(couponFilteringValueState);

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      `coupon?page=${page}&size=10` +
      (searchValue !== "" ? `&${dropDownValue?.value}=${searchValue}` : ``) +
      (filteringValue?.isUse !== 100 ? `&use=${filteringValue?.isUse}` : ``),
  });

  const tableHead = [
    "UID",
    "Code",
    "Promotion",
    "Serv_name",
    "유효 기간",
    "등록 일시",
    "사용 일시",
    "PID",
    "남은 금액",
  ];

  const options: OptionType[] = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
    { value: "phone", label: "전화번호" },
    { value: "code", label: "쿠폰 코드" },
  ];

  const useOptions: OptionType[] = [
    { value: "1", label: "사용" },
    { value: "0", label: "미사용" },
    { value: "2", label: "만료" },
  ];

  useEffect(() => {
    if (couponToastModal) {
      fetchData({
        method: "get",
        url:
          `coupon?page=${page}&size=10` +
          (searchValue !== ""
            ? `&${dropDownValue?.value}=${searchValue}`
            : ``) +
          (filteringValue?.isUse !== 100
            ? `&use=${filteringValue?.isUse}`
            : ``),
      });

      toast.success("쿠폰 지급이 완료되었습니다.", {
        onClose: () => setCouponToastModal(false),
      });
    }
  }, [couponToastModal]);

  useEffect(() => {}, [useDropdownValue, filteringValue]);

  return (
    <>
      <PageTitle title="쿠폰 관리" />

      <CouponManageFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            isDisabled={false}
            setDropDownValue={setDropDownValue}
            dropdownValue={dropDownValue}
            optionList={options}
            boxWidth={180}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            isDisabled={dropDownValue ? false : true}
            pageResetEvent={() => setPage(0)}
            inputType={
              dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
                ? "number"
                : undefined
            }
          />
        </Flex>

        <Flex gapSize={40}>
          <Flex gapSize={10}>
            <FilterIcon maxWidth={1350} />

            {/* 사용 여부 */}
            <DropDown
              isDisabled={false}
              setDropDownValue={setUseDropdownValue}
              dropdownValue={useDropdownValue}
              optionList={useOptions}
              boxWidth={120}
            />

            <ConfirmBtn
              btnText="적용"
              btnColor="mint"
              btnHeight={38}
              btnClickEvent={() => {
                setPage(0);
                setFilteringValue({
                  isUse: Number(useDropdownValue?.value) ?? 100,
                });
              }}
              isDisabled={useDropdownValue?.value === ""}
            />

            <LineBtn
              btnText="초기화"
              icon="refresh"
              btnHeight={38}
              btnColor="mint"
              btnClickEvent={() => {
                setUseDropdownValue({
                  value: "",
                  label: "사용 여부",
                });
                setFilteringValue({
                  isUse: 100,
                });
              }}
              disabled={useDropdownValue?.value === ""}
            />
          </Flex>
          <Flex gapSize={10}>
            <LineBtn
              icon="file_download"
              btnText="쿠폰 Promotion ID"
              btnHeight={38}
              btnClickEvent={() =>
                exportJsonToExcel(couponPromotionData, "couponPromotionData")
              }
            />

            <LineBtn
              icon="add"
              btnText="쿠폰 지급"
              btnHeight={38}
              btnClickEvent={() => setCouponRegisterModal(true)}
              disabled={!auth?.couponAndPoint}
            />
          </Flex>
        </Flex>
      </CouponManageFilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={879}>
          <>
            {response?.data?.items?.map((d: ICoupon) => {
              return (
                <TableBody key={d?.id}>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                  >
                    {d?.uid}
                  </TableBodyItem>
                  <TableBodyItem>{d?.code}</TableBodyItem>
                  <TableBodyItem>{d?.promotion}</TableBodyItem>
                  <TableBodyItem>
                    {d?.servId === 0
                      ? "ALL"
                      : GetServiceSetData(d?.servId)[0]?.SVC_NMKR_TEMP ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem>{d?.expdate}</TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.regdate)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.usedate
                      ? dayjs(d?.usedate)?.format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={d?.partyid === "0" ? false : true}
                    onClick={() => {
                      if (d?.partyid !== "0") {
                        setSavedPage(page);
                        navigate(`/party/info/${d?.partyid}`);
                      }
                    }}
                  >
                    {d?.partyid === "0" ? "-" : d?.partyid}
                  </TableBodyItem>
                  <TableBodyItem>{GetMoneyValue(d?.remain)}</TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        tableHead={tableHead.concat(["aa"])}
        pushedData={(e: any) => {
          return [
            e.uid,
            e.code,
            e.promotion,
            e?.servId === 0
              ? "ALL"
              : GetServiceSetData(e?.servId)[0]?.SVC_NMKR_TEMP ?? "-",
            e.expdate,
            dayjs(e?.regdate)?.format("YYYY-MM-DD HH:mm"),
            e?.usedate ? dayjs(e?.usedate)?.format("YYYY-MM-DD HH:mm") : "-",
            e?.partyid === "0" ? "-" : e?.partyid,
            GetMoneyValue(e?.remain),
          ];
        }}
        dataUrl={
          `coupon?page=0&size=1000` +
          (searchValue !== ""
            ? `&${dropDownValue?.value}=${searchValue}`
            : ``) +
          (filteringValue?.isUse !== 100 ? `&use=${filteringValue?.isUse}` : ``)
        }
        disabled={response?.data?.items?.length < 1}
        title="쿠폰 관리"
      />

      {/* 쿠폰/포인트 지급 모달 */}
      {couponRegisterModal && (
        <CouponPointRegisterModal
          closeEvent={() => setCouponRegisterModal(false)}
          confirmEvent={() => setCouponToastModal(true)}
        />
      )}

      {loading && <Loader />}
    </>
  );
}

const CouponManageFilterContainer = styled(PartyInfoFilterContainer)`
  @media screen and (max-width: 1350px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
